export default __webpack_public_path__ + "a9a014c9fe2cf049eced97d40ca9fe62.png";